import script from "./GalleryHeaderSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryHeaderSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./GalleryHeaderSkeleton.vue?vue&type=style&index=0&id=64553d12&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64553d12"]])

export default __exports__